var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"width":_vm.width,"heightPopup":_vm.height,"closePopupEvent":_vm.closePopupCB}},[_c('div',{staticClass:"session-exp-popup"},[_c('div',{staticClass:"popup-form"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }